import api from '@/utils/api';

/**
 * Create a single part number and return the created part number data
 * @param {object} partNumberData - The part number data
 * @param {string} companyId - the companyId
 * @returns {Promise}
 */
const createSinglePartNumber = (partNumberData, companyId) =>
  api.post(`/company/${companyId}/price/create`, partNumberData);

export default createSinglePartNumber;
